import { Box } from '@chakra-ui/react';
import type { AffiliatePreviewItem } from '@fluenceur/types';
import { SelectedAvatarsCluster } from '@/components/ui/selected-avatars-cluster';
import { browseColors } from './browse-tokens';

interface ProgramCardAvatarsProps {
  /** Compact affiliate preview from the list payload (backend caps at 3). */
  preview: AffiliatePreviewItem[] | undefined;
  /** Total affiliates on the program; drives the "+N" overflow chip. */
  totalCount: number;
}

/**
 * Affiliate avatar pile on a program card: a thin mapper over the shared
 * SelectedAvatarsCluster, restyled per the browse spec (24px, -7px overlap,
 * 2px white ring by border, warm fallback). Renders nothing without a preview.
 */
const ProgramCardAvatars = ({ preview, totalCount }: ProgramCardAvatarsProps) => {
  if (!preview?.length) {
    return null;
  }

  const people = preview.map((affiliate) => ({
    id: affiliate.userId,
    name: affiliate.name,
    avatarUrl: affiliate.avatar?.fileUrl ?? null,
  }));

  return (
    <Box ml="auto">
      <SelectedAvatarsCluster
        people={people}
        totalCount={totalCount}
        avatarSize="24px"
        overlap="-7px"
        avatarBorder={`2px solid ${browseColors.avatarRing}`}
        fallbackBg={browseColors.avatarFallbackBg}
      />
    </Box>
  );
};

export default ProgramCardAvatars;
